import { render, staticRenderFns } from "./ReportedContentMediaPreview.vue?vue&type=template&id=52ea2c8c&"
import script from "./ReportedContentMediaPreview.vue?vue&type=script&lang=js&"
export * from "./ReportedContentMediaPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports